// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Header_headerWrapper__2KXz0","title":"Header_title__TR2BO","form":"Header_form__1eFEK"};